export default __webpack_public_path__ + "static/media/partnershipIcon.a402d779.png";